import { AlertIcon, BitcoinLightningIcon, CheckIcon, FailedIcon, LockLockedIcon } from '@arcade/web/icons/react'
import { IconMat } from '@cash-design-system/react'
import { StatusResultIcon } from '@cash-web/protos/squareup/franklin/status_result.pb'

export const BlockerStatusResultIcon = ({
  name,
  width = '3rem',
  statusText,
}: {
  name?: StatusResultIcon
  width?: string
  statusText?: string
}) => {
  if (!name || name === 'NONE') {
    return null
  }

  const statusResultIconToDesignSystemName: {
    [key in Exclude<StatusResultIcon, 'NONE'>]: { icon?: React.ReactElement; color?: string } | undefined
  } = {
    // If color is not set then we use the icon's default color from the design system.
    FAILURE: {
      icon: (
        <IconMat variant="danger" size="small">
          <FailedIcon size={24} />
        </IconMat>
      ),
    },
    SUCCESS: {
      icon: (
        <IconMat size="medium">
          <CheckIcon size={32} />
        </IconMat>
      ),
    },
    INSTANT: {
      icon: (
        <IconMat size="medium">
          <BitcoinLightningIcon size={32} variant="inverse" />
        </IconMat>
      ),
    },
    BANK: {
      icon: (
        <IconMat variant="danger" size="small">
          <AlertIcon size={24} variant="inverse" />
        </IconMat>
      ),
    },
    ACCOUNT_LOCKED: {
      icon: (
        <IconMat size="small">
          <LockLockedIcon size={24} />
        </IconMat>
      ),
    },
    ACTION_REQUIRED: {
      icon: (
        <IconMat variant="danger" size="small">
          <AlertIcon size={24} variant="inverse" />
        </IconMat>
      ),
    },
    // The following icons need correct icon names. Some might not exist in design system yet.
    PENDING: undefined, // find the right icon: https://block.atlassian.net/browse/FSWEB-11161
    VERIFICATION_REQUIRED: undefined, // find the right icon: https://block.atlassian.net/browse/FSWEB-11160
    PACKAGE: undefined, // find the right icon: https://block.atlassian.net/browse/FSWEB-11170
  }

  const iconInfoInDesignSystem = statusResultIconToDesignSystemName[name]

  if (!iconInfoInDesignSystem) {
    return null
  }

  return iconInfoInDesignSystem.icon
}
